import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackService } from '../services/feedback.service';
import { Globals } from '../globals';
declare var $, unescape, escape, Tour, tour: any;

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent implements OnInit {

  submit_true;
  QuestionList;
  percent;
  UserId;
  SelectedName;
  attemptQue;
  FirstName;
  MaltiRater;
  ParentId;

  constructor(public globals: Globals, private router: Router, private FeedbackService: FeedbackService) { }

  ngOnInit() {

    this.FirstName = localStorage.getItem('FirstName');
    this.MaltiRater = localStorage.getItem('MaltiRater');
    this.ParentId = localStorage.getItem('ParentId');
    var currentYear = (new Date()).getFullYear();
    $("#footer_year").html(currentYear);
    this.UserId = localStorage.getItem('UserId');
    this.SelectedName = localStorage.getItem('SelectedName');
    if (this.UserId > 0) {
      this.globals.pageTitle = '- Feedback';
      this.submit_true = true;
      this.QuestionList = {};
      $('.grey_content').removeClass('tour_guide_block');
      $('#DescriptionModal').modal('show');
      let addpro = 0;
      this.percent = addpro.toFixed(0);
      this.attemptQue = 0;
      $('.progress-bar').css("width", addpro + "%");
      $('#slider').flexslider({
        animation: "slide",
        controlNav: false,
        animationLoop: false,
        slideshow: false,
        smoothHeight: true,
        sync: "#carousel"
      });
      $('body').tooltip({
        selector: '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])',
        trigger: 'hover',
        container: 'body'
      }).on('click mousedown mouseup', '[data-toggle="tooltip"], [title]:not([data-toggle="popover"])', function () {
        $('[data-toggle="tooltip"], [title]:not([data-toggle="popover"])').tooltip('destroy');
      });
      setTimeout(() => {
        if ($("body").height() < $(window).height()) {
          $('footer').addClass('footer_fixed');
        } else {
          $('footer').removeClass('footer_fixed');
        }
      }, 500);
    } else {
      this.router.navigate(['/welcome']);
    }

    checkCookie_eu();

    function checkCookie_eu() {

      var consent = getCookie_eu("cookies_consent");

      if (consent == null || consent == "" || consent == undefined) {
        // show notification bar
        $('#cookie_directive_container').show();
      }

    }

    function setCookie_eu(c_name, value, exdays) {

      var exdate = new Date();
      exdate.setDate(exdate.getDate() + exdays);
      var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
      document.cookie = c_name + "=" + c_value + "; path=/";

      $('#cookie_directive_container').hide();
    }


    function getCookie_eu(c_name) {
      var i, x, y, ARRcookies = document.cookie.split(";");
      for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
        x = x.replace(/^\s+|\s+$/g, "");
        if (x == c_name) {
          return unescape(y);
        }
      }
    }



    $(document).ready(function () {
      $(".flex-next").click(function (event) {
        event.preventDefault();
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

    });

    $(".flex-prev").click(function (event) {
      event.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    });


  }

  close_cookie() {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + 30);
    var c_value = escape(1) + ((30 == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = "cookies_consent =" + c_value + "; path=/";

    $('#cookie_directive_container').hide();
  }

  startTour() {
    $('.grey_content').addClass('tour_guide_block');
    var tour = new Tour({
      smartPlacement: false,
      backdrop: true,
      steps: [{
        element: ".first_question .content",
        placement: 'bottom',
        content: "These are the questions for which you provide a response."
      }, {
        element: ".first_question .rating",
        placement: 'top',
        content: "For each statement, you will be asked to select one of the five response categories below."
      }, {
        element: ".category_desc",
        placement: 'left',
        content: "This describes the feedback category for the statements you provide a response."
      },/* {
          element: ".flex-next",
          placement: 'top',
          content: "This will give the next more questions."
      }, */ {
        element: "#submit_btn .next_btn",
        placement: 'top',
        content: "Click on the submit button when your responses are final."
      },
      {
        element: ".progress_block",
        placement: 'top',
        content: "This will show your progress."
      }
      ]
    });
    tour.init();
    tour.restart();
    tour.start(true);
  }

  finalSubmit() {
    $('#PreviewModal').modal('show');
  }

  save() {

    this.globals.isLoading = true;
    this.QuestionList.UserId = localStorage.getItem('UserId');
    this.QuestionList.ParentId = this.ParentId;
    this.QuestionList.Delivering = (+this.QuestionList.rate1 + +this.QuestionList.rate2 + +this.QuestionList.rate3 + +this.QuestionList.rate4) / 4;
    this.QuestionList.Receiving = (+this.QuestionList.rate5 + +this.QuestionList.rate6 + +this.QuestionList.rate7 + +this.QuestionList.rate8 + +this.QuestionList.rate9) / 5;
    this.FeedbackService.submitFeedback(this.QuestionList)
      .then((data) => {
        this.globals.isLoading = false;
        $('#PreviewModal').modal('hide');
        if (this.ParentId > 0) {
          localStorage.removeItem('UserId');
          localStorage.removeItem('ParentId');
        }

        localStorage.setItem('rate1', this.QuestionList.rate1);
        localStorage.setItem('rate2', this.QuestionList.rate2);
        localStorage.setItem('rate3', this.QuestionList.rate3);
        localStorage.setItem('rate4', this.QuestionList.rate4);
        localStorage.setItem('rate5', this.QuestionList.rate5);
        localStorage.setItem('rate6', this.QuestionList.rate6);
        localStorage.setItem('rate7', this.QuestionList.rate7);
        localStorage.setItem('rate8', this.QuestionList.rate8);
        localStorage.setItem('rate9', this.QuestionList.rate9);
        localStorage.setItem('Delivering', this.QuestionList.Delivering);
        localStorage.setItem('Receiving', this.QuestionList.Receiving);
        //this.router.navigate(['/feedback-score']);
        window.location.href = '/feedback-score';
      },
        (error) => {
          this.globals.isLoading = false;
          this.router.navigate(['/pagenotfound']);
        });
  }

  selectRadio() {
    this.checkprogress();
  }

  checkprogress() {
    let k = 0;
    for (let i = 1; i < 10; i++) {
      if (this.QuestionList['rate' + i]) {
        k++;
      }
    }
    let addpro = (100 * k) / 9;
    this.percent = addpro.toFixed(0);
    this.attemptQue = k;
    $('.progress-bar').css("width", addpro + "%");
    if (k == 9) {
      this.submit_true = false;
    } else {
      this.submit_true = true;
    }
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/OESS_LFB_V2demo/src/app/feedback/feedback.component.ts